import { render, staticRenderFns } from "./batchRegist.vue?vue&type=template&id=debaa3ec&"
import script from "./batchRegist.vue?vue&type=script&lang=js&"
export * from "./batchRegist.vue?vue&type=script&lang=js&"
import style0 from "./batchRegist.vue?vue&type=style&index=0&id=debaa3ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports